export const GET_ENGAGEMENTS_TOTAL_ORDERS_REQUEST = 'GET_ENGAGEMENTS_TOTAL_ORDERS_REQUEST';
export const GET_ENGAGEMENTS_TOTAL_ORDERS_SUCCESS = 'GET_ENGAGEMENTS_TOTAL_ORDERS_SUCCESS';
export const GET_ENGAGEMENTS_TOTAL_ORDERS_FAILURE = 'GET_ENGAGEMENTS_TOTAL_ORDERS_FAILURE';
